import moment from 'moment-timezone'
import { DEFAULT_TIMEZONE } from './constants'

export function summarizeSymptoms (entries = []) {
  const types = []
  const symptoms = []
  entries.forEach(entry => {
    if (entry.superType === 'symptom' || entry.superType === 'exercise') {
      if (!types.includes(entry.superType)) {
        symptoms.push(entry)
        types.push(entry.superType)
      }
    } else {
      if (!types.includes(entry.type)) {
        symptoms.push(entry)
        types.push(entry.type)
      }
    }
  })
  return symptoms
}

export function orderByDate (arr, timeFieldName) {
  return arr.sort((first, second) => {
    if (moment.utc(first[timeFieldName]) > moment.utc(second[timeFieldName])) {
      return 1
    } else if (moment.utc(second[timeFieldName]) > moment.utc(first[timeFieldName])) {
      return -1
    } else {
      return 0
    }
  })
}

export function aggregateEntries (snapshot, ordered, notifications = [], date = new Date()) {
  let entries = []
  const entryTypes = Object.keys(snapshot).filter(key => key.includes('_entries'))

  // display symptoms first, then all other entry types
  const symptomIdx = entryTypes.indexOf('symptom_entries')
  if (symptomIdx >= 0) {
    entries = entries.concat(snapshot['symptom_entries'])
    entryTypes.splice(symptomIdx, 1)
  }

  entryTypes.forEach(type => {
    entries = entries.concat(snapshot[type].map(obj => Object.assign({}, obj, {superType: type.split('_')[0]})))
  })

  notifications.forEach(notification => {
    const sameDate = moment.tz(notification.time, DEFAULT_TIMEZONE).isSame(date, 'date')
    if (sameDate) {
      entries.push({
        time: notification.time,
        type: 'high_temp',
        superType: 'notification'
      })
    }
  })

  entries = entries.concat(notifications.filter(n => n.end).map(notification => ({
    time: notification.end,
    type: 'normal_temp',
    superType: 'notification'
  })))

  if (ordered) {
    return orderByDate(entries, 'time')
  } else {
    return entries
  }
}



// WEBPACK FOOTER //
// ./src/utils.js